<template>
  <v-dialog v-model="userBaned" persistent width="max-content">
    <transition :duration="150">
      <div v-if="userBaned" class="body">
        <svg
          width="53"
          height="60"
          viewBox="0 0 53 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.5 26.25V18.75C7.5 13.7772 9.47544 9.00805 12.9917 5.49175C16.5081 1.97544 21.2772 0 26.25 0C31.2228 0 35.9919 1.97544 39.5083 5.49175C43.0246 9.00805 45 13.7772 45 18.75V26.25C46.9891 26.25 48.8968 27.0402 50.3033 28.4467C51.7098 29.8532 52.5 31.7609 52.5 33.75V52.5C52.5 54.4891 51.7098 56.3968 50.3033 57.8033C48.8968 59.2098 46.9891 60 45 60H7.5C5.51088 60 3.60322 59.2098 2.1967 57.8033C0.790176 56.3968 0 54.4891 0 52.5V33.75C0 31.7609 0.790176 29.8532 2.1967 28.4467C3.60322 27.0402 5.51088 26.25 7.5 26.25ZM37.5 18.75V26.25H15V18.75C15 15.7663 16.1853 12.9048 18.295 10.795C20.4048 8.68526 23.2663 7.5 26.25 7.5C29.2337 7.5 32.0952 8.68526 34.205 10.795C36.3147 12.9048 37.5 15.7663 37.5 18.75Z"
            fill="#EC1B0E"
          />
        </svg>
        <p>{{ localStorage.translations.pages.common.text.account_is_blocked }}</p>
        <button class="exit" @click="logout">
          {{ localStorage.translations.pages.auth.buttons.vyhod }}
        </button>
      </div>
    </transition>
  </v-dialog>
</template>

<script>
export default {
  name: 'BanModal',
  computed: {
    userBaned() {
      return this.$store.getters['user/userBaned']
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'Login' }).catch(() => {})
        this.$store.commit('user/setUserUnBaned')
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.body {
  background: #ffffff;
  padding: 30px;
  display: grid;
  justify-content: center;
  justify-items: center;
  grid-row-gap: 30px;
  p {
    font-weight: normal;
    font-size: 24px;
    color: #2c2c2c;
  }
  .exit {
    padding: 20px 40px;
    font-size: 14px;
    width: max-content;
    background: #277faf;
    height: max-content;
    text-transform: uppercase;
    color: #ffffff;
    border-radius: 28px;
    transition: 0.3s;
    text-decoration: none;
    &:hover {
      background: #16558f;
    }
  }
}
</style>
